<template>
  <div class="logo-card" :class="theme">
    <div class="logo-card-content">
      <img :src="logo" width="135" />
      <p>
        <slot>Está com alguma <strong>dúvida jurídica</strong>?</slot>
      </p>
      <router-link
        :to="{ name: 'page_contact' }"
        class="button is-small"
        :class="buttonClass"
      >
        <template v-if="theme === 'blue'">
          <img src="@/assets/img/svg/white_whatsapp.svg" class="icon" />
          <span>TIRAR DÚVIDA</span>
        </template>
        <template v-else-if="theme === 'orange'"> AGENDAR AGORA </template>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: ["theme"],

  computed: {
    logo() {
      let image = "logo_icon_left.svg";

      if (this.theme === "orange") {
        image = "white_logo.svg";
      }

      return require(`@/assets/img/svg/${image}`);
    },

    buttonClass() {
      return { orange: "button-blue", blue: "button-orange" }[this.theme];
    },
  },
};
</script>

<style>
</style>
